import React from 'react';
import Spinner from '../Global/Spinner/Spinner';
import MaintenanceMode from '../Global/MaintenanceMode/MaintenanceMode';
import ProtectedView from '../Global/ProtectedView/ProtectedVIew';
import { isAlreadyLogged } from '../../utils';

const PageLoader = ({ config, page, favicon, context, children }) => {
  const { protectedPage } = page;

  if (typeof window === 'undefined') {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </div>
    );
  }

  if (config?.maintenanceMode) {
    return <MaintenanceMode page={page} favicon={favicon} />;
  }

  if (protectedPage && !isAlreadyLogged(page)) {
    return <ProtectedView page={page} context={context} favicon={favicon} />;
  }

  return <>{children}</>;
};

export default PageLoader;
